import React from "react";
import styles from "./index.module.scss";
import classes from "classnames";

export interface InlineProgressProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  label: string;
  value: number;
}

const InlineProgress = ({
  className,
  label,
  value,
  ...props
}: InlineProgressProps) => {
  return (
    <div {...props} className={classes(styles.inlineProgress, className)}>
      <div className={styles.progressBar}>
        <div className={styles.filled} style={{ width: value + "%" }} />
      </div>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}%</div>
    </div>
  );
};

export default InlineProgress;
